import styled from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'
import { Box } from '@sainsburys-tech/fable'

const StyledBox = styled(Box)`
  border-color: #737373;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Container = styled.button`
  display: flex;
  flex-direction: row;
  margin: 0 0 16px 0;
  width: 100%;
`

const TextContainer = styled.div`
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
  align-self: center;
  margin-left: 10px;
  line-height: 1.5rem;
  text-align: left;

  &:hover,
  &:active {
    cursor: pointer;
  }
`

const Label = styled.span`
  display: flex;
  align-items: start;
  vertical-align: middle;

  > svg {
    margin-right: 8px;
  }
`

const Link = styled.span`
  color: #016fba; // Matching Paypal pay in 3 widget which is uncustomisable, Will be replaced with theme token when we move all to our own payment component.

  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
  align-items: center;
  vertical-align: middle;
  display: inline-block;
  transform: translateY(-1px);

  &:hover,
  &:active {
    cursor: pointer;
  }
`
const Terms = styled.div`
  font-size: ${props => props.theme.font.size.caption};
  text-align: left;
  margin-top: 8px;
`

const LabelImage = styled(Image)`
  vertical-align: middle;
  margin-right: 8px;
`

export { Container, Label, Link, LabelImage, TextContainer, Terms, StyledBox }
